// Popup d'installation au lancement — seule occasion d'installer le jeu, au plus une fois par
// session : dès qu'on sait que l'installation est proposable (immédiat sur iOS, ou dès que le
// navigateur émet son invite native), et jamais si le jeu tourne déjà en version installée
// (standalone). L'appelant décide si elle est due (espacement entre deux propositions) et est
// prévenu à chaque affichage pour mémoriser la date.
// Une fois "Oui" ou "Plus tard" choisi, elle ne réapparaît plus sans recharger la page.
import { $, show, hide } from './dom.js';

/**
 * @param {ReturnType<typeof import('./install.js').createInstallOffer>} installOffer
 * @param {object} [options]
 * @param {boolean} [options.due=true]      false : déjà proposée récemment, ne rien montrer
 * @param {() => void} [options.onPresented] appelé quand la popup s'affiche
 */
export function offerInstallOnce(installOffer, { due = true, onPresented } = {}) {
  const popup = $('installLaunchPopup');
  const btnYes = $('btnInstallLaunchYes');
  const btnLater = $('btnInstallLaunchLater');
  let offered = false;
  let unsubscribe = null;

  function present() {
    if (offered) return;
    offered = true;
    unsubscribe?.();
    show(popup);
    onPresented?.();
  }

  function dismiss() {
    hide(popup);
  }

  btnYes.addEventListener('click', () => {
    dismiss();
    installOffer.trigger();
  });
  btnLater.addEventListener('click', dismiss);

  if (!due) return;
  if (installOffer.getMode() !== 'none') {
    present(); // iOS : connu tout de suite, pas besoin d'attendre un événement
  } else {
    // Android/Chrome : l'invite native (beforeinstallprompt) arrive un peu après le chargement
    unsubscribe = installOffer.onChange(() => {
      if (installOffer.getMode() !== 'none') present();
    });
  }
}
